import { useState } from "react";
import { useTranslation } from "react-i18next";
import { InfiniteScroll } from "../../../components";
import { EndPoints } from "../../../Constants/endpoints";
import AddMedicalRecordToPatient from "./AddMedicalRecordToPatient";
import MakeNewTemplate from "./MakeNewTemplate";
import TemplateCard from "./TemplateCard";
import { useGetPersonalInfo } from "../../../hooks";

function MedicalRecordTemplates() {
  const { t } = useTranslation();
  const [templatesData, setTemplatesData] = useState<any[]>([]);
  const [defaultTemplatesData, setDefaultTemplatesData] = useState<any[]>();
  const { isAllowed } = useGetPersonalInfo();

  return (
    <div className="flex max-h-full flex-col gap-4 text-lg font-bold text-[#212B36]">
      <div className="box">
        <div className="flex flex-wrap items-center justify-between pb-3">
          <h2 className="mb-4">{t("dome_care_templates")}</h2>
          <div className="flex flex-wrap items-center gap-4">
            <AddMedicalRecordToPatient />
            <MakeNewTemplate />
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 overflow-auto sm:grid-cols-2 md:grid-cols-3 lg:max-h-[32vh] lg:grid-cols-4 xl:grid-cols-5">
          {defaultTemplatesData?.map((template: any, i) => (
            <TemplateCard
              key={i}
              item={template}
              route={`/medical-record-templates/${template?.Id}/details`}
            />
          ))}
          <InfiniteScroll
            Count={10}
            skeletonCount={4}
            enabled={isAllowed}
            endpoint={EndPoints.MedicalHistoryTypes}
            getAllParams={{
              IsGeneralMedical: true,
            }}
            getData={(data) => setDefaultTemplatesData(data)}
            renderSkeleton={
              <div className="mt-3 h-40 animate-pulse rounded-lg bg-gray-400"></div>
            }
          />
        </div>
      </div>
      <div className="box overflow-auto">
        <h3 className="mb-4">{t("my_templates")}</h3>
        <div className="grid grid-cols-1 gap-4 overflow-auto sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {templatesData?.map((template: any, i) => (
            <TemplateCard
              key={i}
              item={template}
              isEditable
              route={`/medical-record-templates/${template?.Id}/details`}
            />
          ))}
          <InfiniteScroll
            Count={10}
            skeletonCount={4}
            enabled={isAllowed}
            endpoint={EndPoints.MedicalHistoryTypes}
            getAllParams={{
              IsGeneralMedical: false,
            }}
            getData={(data) => setTemplatesData(data)}
            renderSkeleton={
              <div className="h-40 animate-pulse rounded-lg bg-gray-400"></div>
            }
          />
        </div>
      </div>
    </div>
  );
}

export default MedicalRecordTemplates;
